// extracted by mini-css-extract-plugin
module.exports = {"rootinner":"product_rootinner_3hMr0"};